import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('#popular-models-slide')) {
        return;
    }

    new Splide('#popular-models-slide', {
        perPage: 4,
        perMove: 1,
        loop: true,
        pagination: true,
        rewind: true,
        arrows: true,
        autoplay: false,
        arrowPath: "",
        breakpoints: {
            1440: {
                perPage: 4,
            },
            1250: {
                perPage: 3,
            },
            900: {
                perPage: 1,
                arrows: false
            },
        }
    }).mount();
});